// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "../../../Swiper/style.css";
import "./Component/style.css";
// import required modules
import { Navigation, Autoplay } from "swiper";
import CompA from "./Component/CompA";
import CompB from "./Component/CompB";

export default function Home() {
  return (
    <>
      <Swiper
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        navigation={true}
        modules={[Navigation, Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide>
          <CompA />
        </SwiperSlide>
        <SwiperSlide>
          <CompB />{" "}
        </SwiperSlide>
      </Swiper>
    </>
  );
}
